import React, { useEffect, useState, useRef } from "react";
import { Button , Table , message , Modal ,Row, Col, Input, Space, Switch} from "antd";
import { SearchOutlined } from '@ant-design/icons';
import '../styles/address-book.style.scss';
import { getAddressLocations } from "../actions/trip-create.actions";
import { useDispatch } from "react-redux";
import { CreateStandardStopsPage } from "./create-standard-stop.page";
import { updateAddressBookOfficeFlag, updatePhoneNumbersOfAddressBook, verifyAddressBook } from "../actions/admin.action";
import { loadingAction } from "../actions/loading-actions";
import { showConfirm } from "../components/custom-components/custom-component";
import { deleteAddressLocation } from "../actions/address.actions";
import useColumnSearch from "../ui-components/table-column-search";
import { VerifyAddressBookModal } from "../components/verify-address-book/verify-address-book.module";
import { checkActionAllowed } from "../utils/utilities";
import { ALLOW_VERIFY_ADDRESS } from "../utils/constant";

const DrawLine =()=>{

    return(
        <div className="address-book-underline">

        </div>
    )
}

const Title = () =>{
        return (
            <div className="title-address-book">
                <h3>
                    Address Book
                </h3>
                <DrawLine />
            </div>
        )
}

const getUniqueCities = (info)=>{
    let cities = [] , citiesInfo = [];
        for (let index = 0; index < info.length; index++) {
            const element = info[index];
            if(cities.indexOf(element.city) == -1){
                cities.push(element.city);
                citiesInfo.push({
                    text:element.city,
                    value:element.city
                  });
            }
        }
        // Sort citiesInfo array alphabetically by city name
        citiesInfo.sort((a, b) => a.text.localeCompare(b.text));
        return citiesInfo;
}

export const AddressBookPage = (props) => {
 
    const [addressBook,setAddressBook] = useState([]);
    const [modalVisiable,setModalVisiable] = useState(false);
    const [selectedRecord,setSelectedRecord] = useState(null);
    const [selectedIds,setSelectedIds] = useState([]);
    const [uniqueCities,setUniqueCities] = useState([]);

    const [phNoModalVisiable,setPhNoModalVisiable] = useState(false);
    const [phoneNumber,setPhoneNumber] = useState(null);
    const [landlineNumber,setLandlineNumber] = useState(null);
    const [phoneNumber3,setPhoneNumber3] = useState(null);

    const [verifyModalVisible,setVerifyModalVisible] = useState(false);
    const [selectedVerifyRecord,setSelectedVerifyRecord] = useState(null);

    const dispatch = useDispatch();

    const getLocations = ()=>{
        dispatch(getAddressLocations(null,false,(data)=>{
            setAddressBook(data.addressLocations);
            setUniqueCities(getUniqueCities(data.addressLocations));
        },(errMsg)=>{
            message.error(errMsg);
        }));
    }

    useEffect(()=>{
        getLocations();
    },[]);

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedIds(selectedRowKeys);
        },
      };

      const setLoading=(bool)=>{
        dispatch(loadingAction(bool));
    }

    const onDeleteClick=()=>{
        showConfirm(()=>{
            setLoading(true);
            deleteAddressLocation(selectedIds,()=>{
                setLoading(false);
                getLocations();
                message.success("Delete location successfully!")
            },(errMsg)=>{
                setLoading(false);
                message.error(errMsg);
            });
        },"Delete Location","Are you sure you want to delete this location?");
    }

    const handleVerifyToggle=(checked,record)=>{
        if(checked){
            // Open modal to get latitude and longitude for verification
            setSelectedVerifyRecord(record);
            setVerifyModalVisible(true);
        }else{
            // Unverify the address (set verified to 0)
            showConfirm(()=>{
                setLoading(true);
                verifyAddressBook(record.id,record.latitude,record.longitude,0,(msg)=>{
                    setLoading(false);
                    message.success("Address unverified successfully!");
                    getLocations();
                },(errMsg)=>{
                    setLoading(false);
                    message.error(errMsg);
                });
            },"Unverify Address","Are you sure you want to unverify this address?");
        }
    }

    const handleOfficeToggle=(checked,record)=>{
        showConfirm(()=>{
            setLoading(true);
            updateAddressBookOfficeFlag(record.id,checked?1:0,(msg)=>{
                setLoading(false);
                message.success(checked?"Marked as Office successfully!":"Marked as Pickup/Drop successfully!");
                getLocations();
            },(errMsg)=>{
                setLoading(false);
                message.error(errMsg);
            });
        },checked?"Mark as Office":"Mark as Pickup/Drop",
        checked?"Are you sure you want to mark this address as an Office?":"Are you sure you want to mark this address as a Pickup/Drop point?");
    }

    const handleVerifyModalOk=(latitude,longitude)=>{
        setLoading(true);
        verifyAddressBook(selectedVerifyRecord.id,latitude,longitude,1,(msg)=>{
            setLoading(false);
            message.success(msg);
            getLocations();
            setVerifyModalVisible(false);
            setSelectedVerifyRecord(null);
        },(errMsg)=>{
            setLoading(false);
            message.error(errMsg);
        });
    }

    const handleVerifyModalCancel=()=>{
        setVerifyModalVisible(false);
        setSelectedVerifyRecord(null);
    }

    return (
        <div className="address-book-page-root">
            <div className="address-book-page-inner-div">
                <Title />
                <Row gutter={[16,16]}>
                    <Col>
                        <Button
                        onClick={()=>{
                            setModalVisiable(true);
                        }}
                        >Create new</Button>
                    </Col>
                    <Col>                    
                        <Button 
                            onClick={()=>{
                                setPhNoModalVisiable(true);
                            }}
                            disabled={selectedIds.length>0?false:true}
                        >Update Phone number</Button>
                    </Col>
                    <Col>
                        <Button
                            disabled={selectedIds.length>0?false:true}
                            onClick={()=>{
                                onDeleteClick();
                            }}
                        >Delete</Button>
                    </Col>
                </Row>
                <Table 
                    dataSource={addressBook}
                    columns={[
                        {
                            title: 'Name',
                            dataIndex: 'name',
                            key: 'name',
                            ...useColumnSearch(
                                {dataIndexExt:"name"}
                            ),
                        },
                        {
                            title: 'City Name',
                            dataIndex: 'city',
                            key: 'city',
                            filters:uniqueCities,
                            onFilter: (value, record) => record.city.indexOf(value) === 0
                        },
                        {
                            title: 'LANDMARK',
                            dataIndex: 'landmark',
                            key: 'landmark'
                        },
                        {
                            title: 'ADDRESS',
                            dataIndex: 'address',
                            key: 'address'
                        } ,
                        {
                            title: 'PHONE 1',
                            dataIndex: 'phone_number',
                            key: 'phone_number',
                            ...useColumnSearch(
                                {dataIndexExt:"phone_number"}
                            ),
                        },
                        {
                            title: 'PHONE 2',
                            dataIndex: 'landline_number',
                            key: 'landline_number',
                            ...useColumnSearch(
                                {dataIndexExt:"landline_number"}
                            ),
                        },
                        {
                            title: 'PHONE 3',
                            dataIndex: 'phone_number3',
                            key: 'phone_number3',
                            ...useColumnSearch(
                                {dataIndexExt:"phone_number3"}
                            ),
                        },
                        {
                            title: 'LATITUDE',
                            dataIndex: 'latitude',
                            key: 'latitude',
                            render:(text)=>{
                                return text || '-';
                            }
                        },
                        {
                            title: 'LONGITUDE',
                            dataIndex: 'longitude',
                            key: 'longitude',
                            render:(text)=>{
                                return text || '-';
                            }
                        },
                        ...(checkActionAllowed(ALLOW_VERIFY_ADDRESS) ? [{
                            title: 'VERIFY',
                            dataIndex: 'verified',
                            key: 'verified',
                            render:(verified,record)=>{
                                return (
                                    <div onClick={(e)=>e.stopPropagation()}>
                                        <Switch 
                                            checked={verified === 1}
                                            onChange={(checked)=>handleVerifyToggle(checked,record)}
                                            checkedChildren="Verified"
                                            unCheckedChildren="Not Verified"
                                        />
                                    </div>
                                );
                            }
                        }] : []),
                        {
                            title: (<span className="office-flag-title">OFFICE /<br/>PICKUP-DROP</span>),
                            dataIndex: 'is_office',
                            key: 'is_office_flag',
                            className: 'office-flag-column',
                            width: 140,
                            filters:[
                                {text:'Office',value:1},
                                {text:'Pickup/Drop',value:0}
                            ],
                            onFilter: (value, record) => (record.is_office ? 1 : 0) === value,
                            render:(isOffice,record)=>{
                                return (
                                    <div onClick={(e)=>e.stopPropagation()}>
                                        <Switch 
                                            className="office-flag-switch"
                                            checked={isOffice == 1}
                                            onChange={(checked)=>handleOfficeToggle(checked,record)}
                                            checkedChildren="Office"
                                            unCheckedChildren="Pickup/Drop"
                                        />
                                    </div>
                                );
                            }
                        }
                    ]}
                    onRow={(record, rowIndex) => {
                        return {
                          onClick: event => {
                            setSelectedRecord({...record});
                            setModalVisiable(true);
                          }, // click row
                          onDoubleClick: event => {
  
                          }, // double click row
                          onContextMenu: event => {
  
                          }, // right button click row
                          onMouseEnter: event => {
  
                          }, // mouse enter row
                          onMouseLeave: event => {
  
                          }, // mouse leave row
                        };
                      }}
                      rowSelection={rowSelection}
                      rowKey={(record) => {
                        return record.id;
                      }}
                      rowClassName="cursorPointer"
                />
                  <Modal
                            title={null} 
                            className="createNewStopModal"
                            modalTitle="Delay Notification"
                            visible={modalVisiable} 
                            width="95vw"
                            onOk={()=>{
                                setModalVisiable(false);
                            }} 
                            onCancel={()=>{
                                setModalVisiable(false);
                                setSelectedRecord(null);
                            }} 
                            centered={true}
                            footer={null}
                        >
                            <div>
                                <CreateStandardStopsPage
                                    fromModal={true} 
                                    isAddressBook={true}
                                    selectedCity={null} 
                                    onSuccessRefresh={(id)=>{
                                        setModalVisiable(false);
                                        setSelectedRecord(null);
                                        getLocations();
                                    }}
                                    operatorCode={global.operatorCode}
                                    onFailure={(errMsg)=>{
                                        message.error(errMsg);
                                    }}
                                    formDetailsFromprops={selectedRecord}
                                    cancelModal={()=>{
                                        setModalVisiable(false);
                                        setSelectedRecord(null);
                                    }}
                                />
                            </div>
                </Modal>
                <Modal
                    title="Update Phone Number"
                    visible={phNoModalVisiable} 
                    onOk={()=>{
                        setLoading(true);
                        updatePhoneNumbersOfAddressBook(selectedIds,phoneNumber,landlineNumber,phoneNumber3,(msg)=>{
                            setLoading(false);
                            message.success(msg);
                            getLocations();
                            setPhNoModalVisiable(false);
                        },(errMsg)=>{
                            setLoading(false);
                            message.error(errMsg);
                        });
                    }} 
                    onCancel={()=>{
                        setPhNoModalVisiable(false);
                    }} 
                    centered={true}
                    okText="Update"
                >
                    <div>
                        <Row gutter={[16,16]}>
                            <Col>
                                <Input 
                                    placeholder="Phone Number 1"
                                    value={phoneNumber}
                                    onChange={(e)=>{
                                        setPhoneNumber(e.target.value);
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row gutter={[16,16]}>
                            <Col>
                                <Input 
                                    placeholder="Phone Number 2"
                                    value={landlineNumber}
                                    onChange={(e)=>{
                                        setLandlineNumber(e.target.value);
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row gutter={[16,16]}>
                            <Col>
                                <Input 
                                    placeholder="Phone Number 3"
                                    value={phoneNumber3}
                                    onChange={(e)=>{
                                        setPhoneNumber3(e.target.value);
                                    }}
                                />
                            </Col>
                        </Row>
                    </div>
                </Modal>
                <VerifyAddressBookModal
                    visible={verifyModalVisible}
                    onCancel={handleVerifyModalCancel}
                    onOk={handleVerifyModalOk}
                    addressRecord={selectedVerifyRecord}
                />
            </div>
        </div>
    );
}